import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter = {
  path: '/proofSheet',
  redirect: 'proofSheet',
  component: Layout,
  children: [
    {
      path: 'proofSheet',
      component: () => import('@/views/proofSheet/index.vue'),
      name: 'proofSheet',
      meta: {
        title: '课题申报管理',
        icon: 'tissue',
        requireAuth: true,
      }
    },
  ]
}

export default equipRouter
